/* template */
<template><div class="package-list"><div class="unclaimed-area"><div class="unclaimed-title"><div class="title-text">可用加速包<mpx-image src="https://ut-static.udache.com/webx/sfc/dgBZrKZ4wLfINBE_2mWPH.png" @tap="jumpToPackIntro" class="question-mark"/>:<div class="num">{{ ownAmount }}</div><div class="expire" v-if="(packageExpire)">{{packageExpire}}</div></div><mpx-view @tap="showPackDetail" class="unclaimed-btn"><div>明细</div><mpx-image src="https://ut-static.udache.com/webx/sfc/HLWBHmH68xKK0NRgyGJ0m.png" class="right-icon"/></mpx-view></div><div v-if="(unclaimed?.length)"><packageItem isStock v-for="(item, index) in (unclaimed)" :packageItem="(item)" :posterUrl="(posterUrl)"/></div><div class="empty" v-else-if="(!unclaimed?.length && !ownAmount)">未领取任何加速包</div></div><div class="divider" v-if="(received?.length)"/><div class="received-area" v-if="(received?.length)"><div class="received-title"><span class="title-text">未领取的加速包</span><span class="received-tip">满足使用条件即可使用</span></div><packageItem v-for="(item, index) in (received)" :packageItem="(item)" :posterUrl="(posterUrl)"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m51770c4b"}'>
  .package-list
    overflow-y auto
    .title-text
      display flex
      align-items center
      font-family PingFangSC-Semibold
      font-size 14px
      font-weight 600
      color #333
      .question-mark
        @extend .expand-click
        height 12px
        width 12px
        margin 0 2px
      .num
        font-family Barlow Semi Condensed
        font-size 20px
        font-weight 400
        line-height 24px
        letter-spacing 0px
        color #F86316
        margin-left 10px
        display flex
        margin-top -1.5px
      .expire
        font-family PingFang SC
        font-size 12px
        line-height 12px
        color #999999
        font-weight normal
        margin-left 5px
    .divider
      height 7px
      width 100%
      background #F6F8FB
    .received-area
      background #fff
      padding 20px 18px
      .received-title
        display flex
        align-items center
        padding-bottom 15px
        .received-tip
          font-family PingFangSC-Regular
          font-size 12px
          font-weight 400
          color #999
          margin-left 5px
    .unclaimed-area
      background #fff
      padding 20px 18px
      padding-top 0
      margin-bottom 7px
      .empty
        font-family PingFangSC-Regular
        font-weight 400
        font-size 12px
        line-height 12px
        letter-spacing 0px
        color #999999
        display flex
        justify-content center
        padding-top 45px
      .unclaimed-title
        display flex
        align-items center
        justify-content space-between
        margin-bottom 15px
        .unclaimed-btn
          display flex
          align-items center
          font-family PingFangSC-Regular
          font-weight 400
          font-size 14px
          line-height 14px
          letter-spacing 0px
          color #999
          .right-icon
            height 8px
            width 4.5px
            margin-left 4.5px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m51770c4b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./package-list.mpx.js?isComponent&outputPath=components%2Fpackage-list51770c4b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./package-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpackage-list51770c4b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m51770c4b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/package-list51770c4b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'packageItem':getComponent(require("./package-item.mpx?isComponent&outputPath=components%2Fpackage-item47719440%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
